<template>
    <div>
        <v-list two-line>
            <template v-for="(item, index) in notas">
                <v-list-item :key="item.id">
                    <template v-slot:default="{ active }">
                        <v-list-item-content>
                            <v-list-item-title
                                class="
                                    text-subtitle-1
                                    font-weight-bold
                                    text-wrap
                                "
                                v-text="
                                    item.comercial
                                        ? item.comercial
                                        : 'Sin comercial'
                                "
                            ></v-list-item-title>
                            <v-list-item-subtitle>
                                <v-list-item-action-text
                                    class="text-subtitle-2"
                                    v-text="formatDate(item.fecha)"
                                ></v-list-item-action-text>
                            </v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action>
                            <v-btn
                                v-if="!$vuetify.breakpoint.smAndDown"
                                color="#2c3a5c"
                                outlined
                                width="180"
                                height="40"
                                @click="showNota(item)"
                            >
                                <v-icon class="mr-md-2">
                                    mdi-sticker-plus
                                </v-icon>

                                Nota
                            </v-btn>
                            <v-btn
                                v-if="$vuetify.breakpoint.smAndDown"
                                color="primary"
                                outlined
                                @click="showNota(item)"
                            >
                                <v-icon class="mr-md-2">
                                    mdi-sticker-plus
                                </v-icon>
                            </v-btn>
                        </v-list-item-action>
                    </template>
                </v-list-item>

                <v-divider
                    v-if="notas && index < notas.length - 1"
                    :key="index"
                ></v-divider>
            </template>

            <v-list-item
                v-if="notas && !notas.length"
                class="d-flex justify-center mt-4 pa-4"
            >
                <div class="display-1 grey--text">
                    Aún no se ha realizado ninguna anotación
                </div>
            </v-list-item>
        </v-list>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    data: () => ({}),
    computed: {
        isOpen() {
            return this.$store.state.teletrabajo.CompleteViewTtForm.dialog
                .IsOpen;
        },
        ...mapState('teletrabajo', {
            notas: (state) => state.CompleteViewTtForm.notas,
            isLoading: (state) => state.CompleteViewTtForm.isLoadingNotas,
        }),
    },
    methods: {
        formatDate(date) {
            let mondate = new Date(date);
            let options = {
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                hour12: false,
                timeZone: 'Europe/Madrid',
            };
            return new Intl.DateTimeFormat('es-ES', options).format(mondate);
        },
        showNota(item) {
            let NotasForm = {
                isOpen: true,
                isSaving: false,
                isEditable: false,
                form: { ...item },
            };
            console.log('este va a ser el formulario');
            console.log(NotasForm);
            this.$store.commit('teletrabajo/NotasForm', NotasForm);
        },
    },
};
</script>
<style>
.v-slide-group__next {
    margin-right: -20px;
}
.v-slide-group__prev {
    margin-left: -20px;
}
</style>